import React, { useState } from "react";
import { Link } from "react-router-dom";

import ImageLight from "../assets/img/forgot-password-office.jpeg";
import ImageDark from "../assets/img/forgot-password-office-dark.jpeg";
import { Label, Input, Button } from "@windmill/react-ui";
import axiosInstance from "../config/axiosInstance";
import { toast } from "react-toastify";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";

function ResetPassword() {
  const [password, setpassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();

  let { slug } = useParams();
  slug = slug.split("/")[slug.split("/").length - 1];

  const history = useHistory();

  const submitHandle = async () => {
    try {
      if (password !== confirmPassword) {
        toast.error("Passwords do not match");
        return;
      }

      const response = await axiosInstance.post("/admin/resetpass", {
        slug: slug,
        password: password,
      });
      console.log(response.data);

      toast.success("Password Was Successfully Changed!");
      history.push("/login/org");
    } catch (error) {
      toast.error(error.response?.data?.error);
    }
  };
  return (
    <div className="flex items-center min-h-screen p-6 bg-gray-50 dark:bg-gray-900">
      <div className="flex-1 h-full max-w-4xl mx-auto overflow-hidden bg-white rounded-lg shadow-xl dark:bg-gray-800">
        <div className="flex flex-col overflow-y-auto md:flex-row">
          <div className="h-32 md:h-auto md:w-1/2">
            <img aria-hidden="true" className="object-cover w-full h-full dark:hidden" src={ImageLight} alt="Office" />
            <img
              aria-hidden="true"
              className="hidden object-cover w-full h-full dark:block"
              src={ImageDark}
              alt="Office"
            />
          </div>
          <main className="flex items-center justify-center p-6 sm:p-12 md:w-1/2">
            <div className="w-full">
              <h1 className="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">Reset Password</h1>

              <Label>
                <span>Password</span>
                <Input
                  className="mt-1"
                  placeholder="*********"
                  onChange={(e) => setpassword(e.target.value)}
                  value={password}
                />
              </Label>
              <Label>
                <span>Confirm Password</span>
                <Input
                  className="mt-1"
                  placeholder="********"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  value={confirmPassword}
                />
              </Label>

              <Button onClick={submitHandle} block className="mt-4">
                Change Password
              </Button>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
